import { Translatable } from './translatable'

export enum QuestionCategory {
  Anger = 'Anger',
  Anxiety = 'Anxiety',
  Addiction = 'Addiction',
  Dating = 'Dating',
  Depression = 'Depression',
  Loneliness = 'Loneliness',
  Relationship = 'Relationship',
  Sleep = 'Sleep',
  Stress = 'Stress',
  Suicidality = 'Suicidality',
}

export enum QuestionType {
  Scale = 'Scale',
  YesNo = 'YesNo',
}

export interface OnboardingQuestion {
  categories: Array<QuestionCategory>
  id: number
  defaultValue: any
  question: Translatable
  type: QuestionType
}

export interface OnboardingResponse {
  question: OnboardingQuestion
  answer: boolean | number
}
